import _ from 'lodash'
import dayjs from 'dayjs'
import { msg, t } from '@lingui/macro'
import { Gender } from '@/core/types/shared'
import { MessageDescriptor } from '@lingui/core'

export function preparePatientsQuery(query: string) {
  if (query === '') return {}
  if (/^\d+$/.test(query) && !isNaN(Number(query))) return { secu: Number(query) }
  return { name: query, surname: query }
}

export const parentValueGenerator = () => ({
  firstname: '',
  lastname: '',
  email: '',
  phone: '',
  city: '',
  cp: '',
})

export function getGenderFromInsNIR(nir: string) {
  switch (nir.charAt(0)) {
    case '1':
      return 'M'
    case '2':
      return 'F'
    default:
      return 'I'
  }
}

export function patientGenderToInsSex(gender: Gender) {
  switch (gender) {
    case 'M':
      return 2
    case 'F':
      return 3
    case 'I':
    default:
      return 1
  }
}

export function getVitalePatientQualityLabel(quality: number) {
  switch (quality) {
    case 0:
      return t`Policyholder` // Assuré
    case 1:
      return t`Parents, children, collateral relatives` // Ascendants, descendants, collatéraux ascendants
    case 2:
      return t`Spouse` // Conjoint
    case 3:
      return t`Ex-spouse` // Conjoint divorcé
    case 4:
      return t`Domestic partner` // Concubin
    case 5:
      return t`Separated spouse` // Conjoint séparé
    case 6:
      return t`Child` // Enfant
    case 8:
      return t`Widowed spouse` // Conjoint veuf
    case 9:
      return t`Other` // Autre
    default:
      return t`Unknown`
  }
}

export function insSexToPatientGender(insSex: number) {
  switch (insSex) {
    default:
    case 1:
      return 'I'
    case 2:
      return 'M'
    case 3:
      return 'F'
  }
}

export function getGenderOptions(): { label: MessageDescriptor; value: Gender }[] {
  return [
    { label: msg`Masculine`, value: 'M' },
    { label: msg`Feminine`, value: 'F' },
    { label: msg`Unknown`, value: 'I' },
  ]
}

export function calculateAge(birthday: Date): number {
  const birthDate = dayjs(birthday)
  const today = dayjs()

  let age = today.diff(birthDate, 'year')

  const hasBirthdayPassed = today.isAfter(birthDate.add(age, 'year'), 'second')

  if (hasBirthdayPassed) {
    return age
  }

  return age - 1
}
